import Amplify, { Auth, Storage } from 'aws-amplify';

import config from './config';

Amplify.configure(config);

// eslint-disable-next-line import/prefer-default-export
export { Amplify, Auth, Storage };
